export default "__VITE_ASSET__CcLd04H2__"